import { Backdrop, CircularProgress } from "@mui/material";

export default function AppLoader() {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: 99999 }}
      open
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
